export interface ProyFinanDesgloseDTO{
    iddecinvproyectofinandesglose: number,
    iddecinvproyectofinanciamiento: number,
    iddecinvproyecto: number,
    rechumaninvestigadores: number,
    rechumanotros: number,
    equipos: number,
    insumos: number,
    inmueblesconstrucciones: number,
    consultorias: number,
    total: number,
    anio: number
}

export function createVoidDesgloseYear(year:number,iddecinvproyecto:number,iddecinvproyectofinanciamiento: number):ProyFinanDesgloseDTO{
    return{
        iddecinvproyectofinandesglose: 0,
        iddecinvproyectofinanciamiento: iddecinvproyectofinanciamiento,
        iddecinvproyecto: iddecinvproyecto,
        rechumaninvestigadores: 0,
        rechumanotros: 0,
        equipos: 0,
        insumos: 0,
        inmueblesconstrucciones: 0,
        consultorias: 0,
        total: 0,
        anio: year
    }
}

export function ListVoidDesgloseYear(anios:Array<number>,iddecinvproyecto:number,iddecinvproyectofinanciamiento: number):Array<ProyFinanDesgloseDTO>{
    let desgloseVoid:Array<ProyFinanDesgloseDTO> = [];
    let orderAnios = anios.slice().sort((a, b) => a - b);
    orderAnios.forEach(anio => {
        let desglose =  createVoidDesgloseYear(anio,iddecinvproyecto,iddecinvproyectofinanciamiento)
        desgloseVoid.push(desglose);
    });
    return desgloseVoid;
}

export interface ProyFinanIntCentDesgloseDTO{
    iddecinvproyectofinandesglose: number,
    iddecinvproyectofinanciamiento: number,
    iddecinvproyecto: number,
    rechumaninvestigadoresDollar: number,
    rechumaninvestigadoresCent: number,
    rechumanotrosDollar: number,
    rechumanotrosCent: number,
    equiposDollar: number,
    equiposCent: number,
    insumosDollar: number,
    insumosCent: number,
    inmueblesconstruccionesDollar: number,
    inmueblesconstruccionesCent: number,
    consultoriasDollar: number,
    consultoriasCent: number,
    total: number,
    anio: number
}

export function createVoidDesgloseYearIntCent(year:number,iddecinvproyecto:number,iddecinvproyectofinanciamiento: number):ProyFinanIntCentDesgloseDTO{
    return{
        iddecinvproyectofinandesglose: 0,
        iddecinvproyectofinanciamiento: iddecinvproyectofinanciamiento,
        iddecinvproyecto: iddecinvproyecto,
        rechumaninvestigadoresDollar: 0,
        rechumaninvestigadoresCent: 0,
        rechumanotrosDollar: 0,
        rechumanotrosCent: 0,
        equiposDollar: 0,
        equiposCent: 0,
        insumosDollar: 0,
        insumosCent: 0,
        inmueblesconstruccionesDollar: 0,
        inmueblesconstruccionesCent: 0,
        consultoriasDollar: 0,
        consultoriasCent: 0,
        total: 0,
        anio: year
    }
}

export function ListVoidDesgloseYearIntCent(anios:Array<number>,iddecinvproyecto:number,iddecinvproyectofinanciamiento: number):Array<ProyFinanIntCentDesgloseDTO>{
    let desgloseVoid:Array<ProyFinanIntCentDesgloseDTO> = [];
    let orderAnios = anios.slice().sort((a, b) => a - b);
    orderAnios.forEach(anio => {
        let desglose =  createVoidDesgloseYearIntCent(anio,iddecinvproyecto,iddecinvproyectofinanciamiento)
        desgloseVoid.push(desglose);
    });
    return desgloseVoid;
}

export function metamorfosisFinanciamientoUnificado(finanIntCent:ProyFinanIntCentDesgloseDTO):ProyFinanDesgloseDTO{
    return{
        iddecinvproyectofinandesglose: finanIntCent.iddecinvproyectofinandesglose,
        iddecinvproyectofinanciamiento: finanIntCent.iddecinvproyectofinanciamiento,
        iddecinvproyecto: finanIntCent.iddecinvproyecto,
        rechumaninvestigadores: casteoDecimal(finanIntCent.rechumaninvestigadoresDollar,finanIntCent.rechumaninvestigadoresCent),
        rechumanotros: casteoDecimal(finanIntCent.rechumanotrosDollar,finanIntCent.rechumanotrosCent),
        equipos: casteoDecimal(finanIntCent.equiposDollar,finanIntCent.equiposCent),
        insumos: casteoDecimal(finanIntCent.insumosDollar,finanIntCent.insumosCent),
        inmueblesconstrucciones: casteoDecimal(finanIntCent.inmueblesconstruccionesDollar,finanIntCent.inmueblesconstruccionesCent),
        consultorias: casteoDecimal(finanIntCent.consultoriasDollar,finanIntCent.consultoriasCent),
        total: finanIntCent.total,
        anio: finanIntCent.anio
    }
}

export function ListDesgloseUnificado(listaDesglo:Array<ProyFinanIntCentDesgloseDTO>):Array<ProyFinanDesgloseDTO>{
    let desgloseVoid:Array<ProyFinanDesgloseDTO> = [];
    listaDesglo.forEach(anio => {
        let desglose =  metamorfosisFinanciamientoUnificado(anio)
        desgloseVoid.push(desglose);
    });
    return desgloseVoid;
}

function separarPartes(numero:number) {
    // Convertir el número a string para poder manipularlo
    const numeroString = numero.toString();
    
    // Separar la parte entera y decimal usando split
    const partes = numeroString.split('.');
    
    // Obtener la parte entera y la parte decimal
    const parteEntera = parseInt(partes[0]);
    const parteDecimal = parseInt(partes[1]) || 0; // Si no hay parte decimal, se asume '00'
    
    return {
        parteEntera,
        parteDecimal
    };
}

export function casteoDecimal(dolares:number,centavos: number):number {
    if(centavos < 10){
        return parseFloat(`${dolares}.0${centavos}`)
    }else{
        return parseFloat(`${dolares}.${centavos}`)
    }
    
}

export function metamorfosisFinanciamientoSeparacionDecimal(finanUnificado:ProyFinanDesgloseDTO):ProyFinanIntCentDesgloseDTO{
    let rechumaninvestigadores= separarPartes(finanUnificado.rechumaninvestigadores)
    let rechumanotros= separarPartes(finanUnificado.rechumanotros)
    let equipos= separarPartes(finanUnificado.equipos)
    let insumos= separarPartes(finanUnificado.insumos)
    let inmueblesconstrucciones= separarPartes(finanUnificado.inmueblesconstrucciones)
    let consultorias= separarPartes(finanUnificado.consultorias)
    return{
        iddecinvproyectofinandesglose: finanUnificado.iddecinvproyectofinandesglose,
        iddecinvproyectofinanciamiento: finanUnificado.iddecinvproyectofinanciamiento,
        iddecinvproyecto: finanUnificado.iddecinvproyecto,
        rechumaninvestigadoresDollar: rechumaninvestigadores.parteEntera,
        rechumaninvestigadoresCent: rechumaninvestigadores.parteDecimal,
        rechumanotrosDollar: rechumanotros.parteEntera,
        rechumanotrosCent: rechumanotros.parteDecimal,
        equiposDollar: equipos.parteEntera,
        equiposCent: equipos.parteDecimal,
        insumosDollar: insumos.parteEntera,
        insumosCent: insumos.parteDecimal,
        inmueblesconstruccionesDollar: inmueblesconstrucciones.parteEntera,
        inmueblesconstruccionesCent: inmueblesconstrucciones.parteDecimal,
        consultoriasDollar: consultorias.parteEntera,
        consultoriasCent: consultorias.parteDecimal,
        total: 0,
        anio: finanUnificado.anio
    }
}

export function ListDesgloseSeparacionDecimal(listaDesglo:Array<ProyFinanDesgloseDTO>):Array<ProyFinanIntCentDesgloseDTO>{
    let desgloseVoid:Array<ProyFinanIntCentDesgloseDTO> = [];
    listaDesglo.forEach(anio => {
        let desglose =  metamorfosisFinanciamientoSeparacionDecimal(anio)
        desgloseVoid.push(desglose);
    });
    return desgloseVoid;
}